import AccountCardEditor from './AccountCardEditor';

export default AccountCardEditor;
